import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasResult',
  standalone: true,
})
export class HasResultPipe implements PipeTransform {
  transform(value: string): boolean {
    const regex = /\((\d+)\)\s*$/;
    const match = value.match(regex);
    if (!match) return true;
    return (match && parseInt(match[1], 10) > 0) || false;
  }
}
